import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import { default as FormState } from 'js/stores/pages/MyAccountPageState/ReceivingAccount';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';
import Icon from './Icon';
import CreditCardForm from "js/components/common/CreditCardForm";

@observer
export default class ChoicesForm extends Component {
  form = this.props.state;

  onAddBankAccount = () => {
    this.form.closeModals();
    this.form.showBankAccountModal();
  }

  onSaveCreditCard = (event, values) => {
    if(!this.form.debitCard.isFilledIn){
      return false;
    }
    values.address = this.form.debitCard.address;
    this.form.saveDebitCard(values);
  }

  render() {
    const form = this.form;
    const notRunningInProduction = window.app.env !== 'production';

    return (
      <Container>
        <Icon name="university" />
        <Title>Receiving account</Title>
        <AvForm onValidSubmit={this.onAddBankAccount}>
          <SubmitRow>
            <p>Get paid into your bank account. It’s free and takes 2 - 3 days</p>
            <Button isLoading={form.isSaving} autoFocus type="submit">
              {form.bankAccount.id ? 'Change bank account' : 'Add bank account'}
            </Button>
          </SubmitRow>
        </AvForm>
        <br/>
        <hr/>
        <br/>

        {
          notRunningInProduction
            ? (
              <>
                <AvForm onValidSubmit={this.onSaveCreditCard}>
                  <p>Get paid instantly to your debit card. (costs $1)</p>
                  <CreditCardForm labels={false} creditCard={form.debitCard} />
                  <SubmitRow>
                    <Button type="submit" isLoading={form.isSavingCard} disabled={!form.debitCard.isFilledIn}>
                      Save
                    </Button>
                  </SubmitRow>
                  <ErrorDisplay>{form.debit_card_error}</ErrorDisplay>
                </AvForm>
                <br/>
                <hr/>
                <br/>
                <p><strong>Note:</strong> You can add both and decide when you’re completing the transaction</p>
              </>
            )
            :
            <></>
        }


      </Container>
    );
  }
}
